var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm._v("오시는 길")])]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('iframe', {
    staticClass: "border-radius-16",
    staticStyle: {
      "border": "0",
      "aspect-ratio": "1200 / 678"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3160.952308677184!2d127.03954497640714!3d37.60328142201932!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357cbb7e79c5198b%3A0x889f6e2ee3aeb6ce!2z7ISc7Jq47Yq567OE7IucIOyEseu2geq1rCDtmZTrnpHroZwxMeq4uCAyNg!5e0!3m2!1sko!2skr!4v1743994301552!5m2!1sko!2skr",
      "width": "100%",
      "allowfullscreen": "",
      "loading": "lazy",
      "referrerpolicy": "no-referrer-when-downgrade"
    }
  })]), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-divider'), _c('div', {
    staticClass: "px-8 py-24"
  }, _vm._l(_vm.items, function (item, index) {
    return _c('v-row', {
      key: index,
      staticClass: "page-text page-text--lg row--xxs",
      attrs: {
        "no-gutters": ""
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-sheet', {
      staticClass: "primary--text",
      attrs: {
        "width": "120"
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")])], 1), _c('v-col', [_vm._v(" " + _vm._s(item.text) + " ")])], 1);
  }), 1), _c('v-divider')], 1)], 1)], 1)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }